import React from 'react';
import { VStack, Alert, AlertIcon, GridItem } from '@chakra-ui/react';
import { useAppContext } from 'src/contexts/AppContext';
import { DataConnectors } from 'src/components/templates/DataConnectors';

export const PreparingYourDataStep: React.FC = () => {
  const { currentCustomer } = useAppContext();

  if (!currentCustomer) {
    return (
      <GridItem colSpan={14} w="100%">
        <Alert status="warning">
          <AlertIcon />
          Please select a customer to manage data integrations
        </Alert>
      </GridItem>
    );
  }

  return (
    <GridItem colSpan={14} w="100%" pb={{ base: 4, md: 10 }}>
      <VStack spacing={6} align="stretch">
        <DataConnectors showFetchStatus={false} />
      </VStack>
    </GridItem>
  );
};
